import React, { useState, useRef } from 'react';

import 'antd/dist/antd.css';
import { Row, Col, Typography, Button, Modal, message } from 'antd';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import icon_menu_dots_white from 'images/icon_menu_dots_white.svg';
import RenameModal from 'components/content/newModal/RenameModal';

const TransformationDropdownMenu = (props) => {
    const ref = useRef();
    const [visible, setVisible] = useState(false);
    const [currentName, setCurrentName] = useState(props.rename);
    const [isModalRename, setIsModalRename] = useState(false);
    useOnClickOutside(ref, () => setVisible(false));

    const handleOpen = () => {
        setVisible(true);
    };

    const handleModalRename = (data) => {
        setVisible(false);
        setIsModalRename(true);
    };

    const handleCurrentName = (e) => {
        setCurrentName(e.target.value);
    };

    const handleOkRename = () => {
        props.setNewName(currentName);
        handleCancelRename();
    };

    const handleCancelRename = () => {
        setIsModalRename(false);
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',

                    position: 'absolute',
                    top: '15px',
                    right: '8px'

                    // zIndex: 100
                }}
                className="dropdown"
                ref={ref}
                onClick={handleOpen}
            >
                <Button
                    style={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        boxShadow: 'none'
                    }}
                    shape="circle"
                >
                    <img
                        src={icon_menu_dots_white}
                        className="icon-menu-dots-svg"
                    />
                </Button>

                <div
                    className={
                        // 'dropdown-content-visible'
                        visible
                            ? 'dropdown-content-visible'
                            : 'dropdown-content-invisible'
                    }
                    style={{
                        right: '0px',
                        bottom: '-40px',
                        width: 'auto',
                        fontSize: '12px',
                        // padding: '0 10px 5px',
                        minWidth: 0
                    }}
                >
                    <button
                        onClick={(e) => {
                            handleModalRename();
                        }}
                        className="button-dropdown"
                        // style={{ padding: '8px 5px 5px 5px' }}
                    >
                        Rename Transformation
                    </button>
                </div>
            </div>

            <RenameModal
                visible={isModalRename}
                onAccept={handleOkRename}
                onCancel={handleCancelRename}
                handleNewRename={handleCurrentName}
                currentName={currentName}
                modalType="renameTransformation"
            />
        </>
    );
};

export default TransformationDropdownMenu;
